import { render, staticRenderFns } from "./DirectoryItem.vue?vue&type=template&id=4f5b2610&scoped=true&"
import script from "./DirectoryItem.vue?vue&type=script&lang=js&"
export * from "./DirectoryItem.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryItem.vue?vue&type=style&index=0&id=4f5b2610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b2610",
  null
  
)

export default component.exports